<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-book page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:300px; max-width:50vw;">
							<div class="input-group">
								<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch($(this).val())" />
								<span class="input-group-text"><i class="fa fa-search"></i></span>
							</div>
						</div>

						<h2>Pénztárgép események / <%= aee.ap %></h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Pénztárgépek</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'aee_event',
						params: {
							row_height: 37,
							columns: [
								{
									title: 'Dátum',
									field: 'event_d',
									type: 'date',
									width: 130
								},
								{
									title: 'Esemény',
									field: 'event',
									type: {
										render: (v) => {
											return {
												start: 'Megszemélyesítés, üzembe helyezés',
												mobile_contract_signed: 'Mobiladat szerződés aláírva',
												mobile_contract_uploaded: 'Mobiladat szerződés feltöltve',
												yearly_inspection_scheduled: 'Éves felülvizsgálat ütemezve',
												yearly_inspection: 'Éves felülvizsgálat',
												repair: 'Javítás',
												rename: 'Átszemélyesítés',
												stop: 'Felfüggesztés',
												other: 'Egyéb',
											}[v]
										}
									},
									options: {
										class: 'text-strong'
									},
									width: 280
								},
								{
									title: 'Megjegyzések',
									field: 'notes',
									type: 'string',
									options: {
										cutoff: 100
									},
									width: 360
								}
							]
						},
						list: aee_events
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-success ml-2" onclick="Anvil.page.new()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új esemény</span></button>
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
					<button class="btn btn-danger ml-2" onclick="Anvil.page.delete()"><i class="fa fa-fw fa-trash"></i><span class="d-none d-md-inline ms-2">Törlés</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	quickSearch (expression) {
		Anvil.models.components.Grid.find('#aee_event_grid').filter(expression)
	},

	async refresh () {
		await Anvil.exec('c_order/aee/action_refresh_log')
	},

	new () {
		Anvil.exec('c_order/aee_event/modal_edit')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#aee_event_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/aee_event/modal_edit', sel[0].id)
		}
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#aee_event_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/aee_event/action_delete', sel[0].id)
		}
	}
})

$('#aee_event_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
